import { usePermissionChangesSubscriber } from 'hooks/use-permission-changes-subscriber.hook';
import useForceReloadSubscriber from 'hooks/use-force-reload-subscriber';
import React, { type ReactNode } from 'react';
import { observer } from 'mobx-react';

const GlobalSubscriptions: React.FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  usePermissionChangesSubscriber();
  useForceReloadSubscriber();

  return <>{children}</>;
};

export default observer(GlobalSubscriptions);
